import { useState } from "react";

import { SnoozeModal, useCan, useSelectedDealer, useSelectedLocation } from "components";
import { useRegisterNavAction } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { NotSnoozedLeadsFilters, NotSnoozedLeadsTable } from "modules/LeadsDashboard/Leads/NotSnoozedLeads/components";
import {
  useDeleteNotSnoozedSnoozeMutation,
  useLeadsNotSnoozedFilters,
  useLeadsNotSnoozedQuery,
  useNotSnoozedAppendSnoozeMutation
} from "modules/LeadsDashboard/Leads/NotSnoozedLeads/hooks";

import type { DeleteSnoozePayload } from "components";
import type { Snooze } from "models";
import type { QuestionResultData } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/types";
import type { AddInterventionPayload } from "modules/AppointmentDetails/hooks";

export const NotSnoozedLeads = () => {
  const [modalData, setModalData] = useState<AddInterventionPayload | QuestionResultData | null>(null);

  const { location_ids, dealer_ids } = useLeadsNotSnoozedFilters();
  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();
  const { mutateAsync: appendSnooze, isPending: isAppendSnoozePending } = useNotSnoozedAppendSnoozeMutation();
  const { mutateAsync: deleteSnooze, isPending: isDeleteSnoozePending } = useDeleteNotSnoozedSnoozeMutation();
  const { refetch: refetchLeadsNotSnoozed, isFetching } = useLeadsNotSnoozedQuery();
  const canCreateSnooze = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.Snooze);

  useRegisterNavAction(() => (dealer_ids.length > 0 || location_ids.length > 0) && refetchLeadsNotSnoozed());

  const handleAppendSnooze = async (snooze: Snooze) => {
    if (!canCreateSnooze) return;
    await appendSnooze(snooze);
  };

  const handleDeleteSnooze = async (payload: DeleteSnoozePayload) => {
    await deleteSnooze(payload);
  };

  return (
    <>
      <NotSnoozedLeadsFilters />
      <NotSnoozedLeadsTable setModalData={setModalData} isLoading={isFetching} />
      {modalData && (
        <SnoozeModal
          size="large"
          dealer={selectedDealer}
          location={selectedLocation}
          data={modalData}
          closeOnDimmerClick
          open={Boolean(modalData)}
          onClose={() => setModalData(null)}
          onAppendSnooze={handleAppendSnooze}
          onDeleteSnooze={handleDeleteSnooze}
          isAppendSnoozeLoading={isAppendSnoozePending}
          isDeleteSnoozeLoading={isDeleteSnoozePending}
        />
      )}
    </>
  );
};
